<template>
  <div class="full-height">
    <jt-data-table-buttons @action-button="actionButtonHandler" @show-message="showMessageHandler" />
    <component :is="dataTableComponent" v-show="hasData" ref="tableRef" :has-data.sync="hasData" v-bind="computedProps">
      <template v-if="!hasScopedSlots" v-slot:header="props">
        <slot name="header" :props="{ ...props }">
          <jt-data-table-header :props="props" @select-all="onSelectAllChangeHandler" />
        </slot>
      </template>
      <template v-if="!hasScopedSlots" v-slot:body="props">
        <slot name="body" :props="{ ...props }">
          <jt-data-table-row :props="props" v-bind="$props" @click-row="onClickRowHandler"
            @action-button="onActionButtonHandler" @toggle-change="(data) => $emit('toggle-change', data)" />
          <jt-data-table-hidden-row :props="props" />
        </slot>
      </template>

      <template v-for="(value, key) in $scopedSlots" v-slot:[key]="props">
        <slot :name="key" :props="props.props" v-bind="{ props: 'props' }">
        </slot>
      </template>
    </component>
    <jt-empty-message v-show="!hasData" :message="messageDataEmpty || $gettext('NO_DATA_AVAILABLE')" size="10em" />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { QTable } from 'quasar'
import { JtLocalDataTable, JtRemoteDataTable, JtDataTableButtons, JtDataTableHeader, JtDataTableRow, JtDataTableHiddenRow, JtDataTable, JtEmptyMessage } from 'jtech-webcomps'
import CommunicationState from './CommunicationState'
@Component({
  provide () {
    return {
      JtDataTable: this
    }
  },
  components: {
    JtEmptyMessage,
    JtDataTableButtons,
    QTable,
    JtDataTableHeader,
    JtDataTableRow,
    JtDataTableHiddenRow,
    JtLocalDataTable,
    JtRemoteDataTable
  },
  mixins: [QTable, JtDataTableRow, JtDataTable],
  props: {
    columnEdit: {
      type: Function
    },
    bottomEdit: {
      type: Function
    },
    rowSet: {
      type: Function
    },
    selectionForce: {
      type: Boolean,
      default: false
    },
    singleselect: {
      type: Boolean
    },
    multiselect: {
      type: Boolean
    },
    buttons: {
      required: false,
      type: Array,
      default: () => []
    },
    rowButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    buttonsFilter: {
      type: Function
    },
    noneselect: {
      type: Boolean
    },
    fields: {
      type: Array,
      required: true,
      default: () => []
    },
    extraParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    defaultHttpOptions: Object,
    nmInterface: String,
    rowKey: {
      type: String,
      default: 'id'
    },
    title: String,
    isPaginated: {
      type: Boolean,
      default: true
    },
    forms: { type: Array },
    apiMode: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: () => []
    },
    messageDataEmpty: {
      type: String,
      default: ''
    },
    imageColumnNotFound: String
  }
})
class JtDataTableClone extends Vue {
  selectAll = false
  selected = []
  hasData = true

  mounted () {
    CommunicationState.$on('refresh-page-search', this.refresh)
  }

  beforeMount () {
    if (
      this.hasHiddenFields &&
      !this.fields.some((field) => field.name === 'showhide')
    ) {
      this.fields.push({
        name: 'showhide',
        visibility: 'show',
        label: this.$gettext('MORE'),
        model: 'showhide'
      })
    }
  }

  onSelectedUpdate (newValue) {
    this.$emit('selection', newValue)
  }

  refresh (params) {
    if (params) {
      this.extraParams = { ...this.extraParams, ...params }
    }
    this.$refs?.tableRef?.refresh()
  }

  actionButtonHandler (payload, param, context) {
    this.$emit('action-button', payload, param, context)
  }

  showMessageHandler (payload, param, context) {
    this.$emit('show-message', payload, param, context)
  }

  onSelectAllChangeHandler (isSelectAll) {
    if (isSelectAll) {
      const data = this.apiMode
        ? this.$refs.tableRef._data.serverData
        : this.$refs.tableRef.data
      this.selected = data
      this.onSelectedUpdate(data)
    } else {
      this.selected = []
      this.onSelectedUpdate([])
    }
  }

  onClickRowHandler (payload, context) {
    this.$emit('click-row', payload, context)
  }

  onActionButtonHandler (button, params, context) {
    this.$emit('action-button', button, params, context)
  }

  removeSelected () {
    this.$set(
      this,
      'data',
      this.data.filter((d) => {
        return !this.selected.some((element) => element == d)
      })
    )
    this.$emit('update:data', this.data)
    this.__cleanSelection()
  }

  label (elem, params) {
    try {
      if (params || (elem.label && elem.label[0] === '$')) {
        const key = elem.label.substring(2, elem.label.length - 1)
        elem.label = params[key] ?? elem.label
      }
    } catch (error) { }
  }

  __cleanSelection () {
    this.selected = []
    this.onSelectedUpdate(this.selected)
  }

  __labelHandler (elem, params) {
    try {
      if (params || (elem.label && elem.label[0] === '$')) {
        const key = elem.label?.substring(2, elem.label.length - 1)
        return params[key] ?? elem.label ?? elem.title
      }
    } catch (error) {
      console.error('__labelHandler', error)
    }
  }

  __proxyRow (data) {
    if (!this.rowSet) return
    const _self = this
    const validator = {
      set: function (obj, prop, value) {
        if (_self.rowSet) return _self.rowSet(obj, prop, value)
        obj[prop] = value
        return true
      }
    }
    for (let i = 0; i < data.length; i++) {
      data[i] = new Proxy(data[i], validator)
    }
  }

  get columns () {
    return this.fields.map((col, index) => {
      col.label = this.__labelHandler(col, { ...this.extraParams })
      col.name = col.name || col.model
      col.field = col.name
      col.align = col.align || 'center'
      if (col.name == 'status') {
        col.sortable = false
      } else {
        col.sortable = true
      }
      return col
    })
  }

  get visibleColumns () {
    return this.fields
      .filter((col) => {
        if (!col.visibility) return true
        return col.visibility && col.visibility !== 'hidden'
      })
      .map((col) => col.name || col.model)
  }

  get hiddenColumns () {
    return this.columns.filter(
      (col) => col.visibility && col.visibility === 'hidden'
    )
  }

  get selectionType () {
    if (this.multiselect) return 'multiple'
    if (this.singleselect) return 'single'
    if (this.noneselect || (!this.multiselect && !this.singleselect)) { return 'none' }
  }

  get computedHideBottom () {
    return !this.isPaginated
  }

  get hasHiddenFields () {
    return this.fields.some(
      (col) => col.visibility && col.visibility === 'hidden'
    )
  }

  get computedSeparator () {
    return (
      this.$options.propsData.separator ??
      this.$jt?.components?.jtDataTable?.separator ??
      this.separator
    )
  }

  get computedBordered () {
    return (
      this.$options.propsData.bordered ??
      this.$jt?.components?.jtDataTable?.bordered ??
      this.bordered
    )
  }

  get buttonsTop () {
    if (this.rowButtons) return []
    return this.buttons.filter((button) => {
      return !button.renderRow
    })
  }

  get buttonsRow () {
    if (!this.rowButtons) {
      return this.buttons.filter((button) => {
        return button.renderRow
      })
    }
    return this.buttons
  }

  get hasButtonRow () {
    return this.buttonsRow.length > 0
  }

  get showSelectRow () {
    return (
      this.selectionForce ||
      ((!this.noneselect || this.singleselect || this.multiselect) &&
        (this.buttons.length == 0 ||
          this.buttonsTop.filter((b) => b.mode != 'NONE').length > 0))
    )
  }

  get computedTableData () {
    return this.apiMode
      ? this.$refs.tableRef._data.serverData
      : this.$refs.tableRef.data
  }

  get computedProps () {
    return {
      ...this.$props,
      separator: this.computedSeparator,
      bordered: this.computedBordered,
      selection: this.selectionType,
      hideBottom: this.computedHideBottom,
      visibleColumns: this.visibleColumns,
      columns: this.columns,
      filter: this.filter,
      hasButtonRow: this.hasButtonRow
    }
  }

  get dataTableComponent () {
    return this.apiMode ? JtRemoteDataTable : JtLocalDataTable
  }

  get hasScopedSlots () {
    return !!Object.entries(this.$scopedSlots).length
  }
}
export default JtDataTableClone
</script>
<style lang="stylus">
@import '~quasar-variables';

.jt-datatable {
  .hidden-row {
    label {
      font-weight: bold;

      &:after {
        content: '  ';
      }
    }

    div {
      text-align: left;
      padding: 0px 10px;
    }
  }

  th, td {
    text-align: center;
  }

  thead tr th {
    position: sticky !important;
    top: 0;
    z-index: 2;
  }

  .q-table__bottom, thead tr {
    background-color: #eceff1;
    box-shadow: 0 1px 0 0 #ddd, 0 -5px 0 0 #fff;
  }

  .q-table thead tr {
    height: 40px;
    text-transform: uppercase;
    color: $grey-7;
    font-weight: 500;
    position: sticky !important;
    top: 0;
    z-index: 2;
  }
}
</style>
